import React, { FC } from 'react'
import { cn } from 'shared/utils'

import { IContainerProps } from './ProjectCreateContainer.props'
import './ProjectCreateContainer.scss'

const ProjectCreateContainer: FC<IContainerProps> = ({ className, children }) => (
  <div className={cn(className, 'project-create-container')}>{children}</div>
)

export default ProjectCreateContainer
